import React from "react";
import { useDebounce } from "utilities/usehooks";

const useChooseUserToClient = (initialInstruction?: Partial<server.dto.PaginatedUserToClientInstruction>) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedUserToClientInstruction>({
    environment: "internal",
    lifeCycles: ["active"],
    page: 1,
    perPage: 15,
    keyword: "",
    ...initialInstruction
  });

  const setLifecycles = (lifeCycles: server.dto.UserToClientLifeCycles[]) => {
    setInstruction(instr => ({
      ...instr,
      page: 1,
      lifeCycles
    }));
  };

  const setEnvironment = (environment: server.dto.Environments) => {
    setInstruction(instr => ({
      ...instr,
      page: 1,
      environment
    }));
  };

  const setPage = (page: number) => {
    setInstruction(instr => ({
      ...instr,
      page
    }));
  };

  const setKeyword = (keyword: string) => {
    setInstruction(instr => ({
      ...instr,
      page: 1,
      keyword
    }));
  };

  const debouncedInstruction = useDebounce(instruction);

  return {
    setEnvironment,
    setLifecycles,
    setPage,
    setKeyword,
    setInstruction,
    instruction,
    debouncedInstruction
  };
};

export default useChooseUserToClient;